import React, { useState, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {
  Row,
  Col,
  PageHeader,
  Table,
  Form,
  Checkbox,
  Spin,
  Button,
} from 'antd';
import UserSelector from '../components/userSelector';
import * as api from './api';
import './index.less';

const userColumns = [
  { title: '用户名', dataIndex: 'userName' },
  { title: '手机号', dataIndex: 'phone' },
  {
    title: '权限',
    dataIndex: 'roles',
    render: text => text.join(', '),
  },
];

const Initiate = ({ id, disabled, onChange }) => {
  const { goBack } = useHistory();

  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState([]);
  // 查询用户名
  const handleQueryMembers = useCallback(
    () =>
      api.queryMembers({ id }).then(res => {
        const data =
          res.data.records.reduce((acc, record) => {
            const { accountId, user, roleName } = record;
            const item = acc[accountId] || (acc[accountId] = user);
            if (!item.roles) item.roles = [];
            item.roles.push(roleName);
            return acc;
          }, {}) || {};
        setUsers(Object.values(data));
        setTotal(res.data.total);
      }),
    [id]
  );
  // 初始化
  useEffect(() => {
    setLoading(true);
    const promises = [
      api.getRoles().then(res => setRoles(res.data)),
      handleQueryMembers(),
    ];
    Promise.all(promises).finally(() => setLoading(false));
  }, [handleQueryMembers, id]);

  const handleCreateMember = useCallback(
    form => {
      setLoading(true);
      const params = { id, ...form };
      api
        .createMember(params)
        .then(res => {
          handleQueryMembers();
          onChange && onChange(params, res);
        })
        .finally(() => setLoading(false));
    },
    [handleQueryMembers, id, onChange]
  );
  const handleRemoveMember = useCallback(
    accountId => e =>
      api.removeMember({ id, accountId }).then(handleQueryMembers),
    [handleQueryMembers, id]
  );

  const formatUserColumns = useMemo(
    () =>
      userColumns.concat({
        title: '操作',
        key: 'action',
        render(_, record) {
          return (
            <>
              <Button
                type="link"
                danger
                onClick={handleRemoveMember(record.accountId)}
                disabled={disabled}
              >
                删除
              </Button>
            </>
          );
        },
      }),
    [handleRemoveMember, disabled]
  );

  return (
    <Spin spinning={loading}>
      <PageHeader title="发起" />
      <Row>
        <Col span={8}>
          <Form name="initiate" layout="vertical" onFinish={handleCreateMember}>
            <Form.Item
              name="accountId"
              rules={[{ required: true, message: '必须选择一个用户' }]}
            >
              <UserSelector style={{ width: 200 }} disabled={disabled} />
            </Form.Item>
            <Form.Item
              label="权限"
              name="roleIds"
              rules={[{ required: true, message: '必须选择一个权限' }]}
            >
              <Checkbox.Group disabled={disabled}>
                {roles.map(role => (
                  <Checkbox key={role.id} value={role.id}>
                    {role.name}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </Form.Item>
            <Form.Item>
              <Button onClick={goBack}>取消</Button>
              <Button
                style={{ margin: '0 20px' }}
                type="primary"
                htmlType="submit"
                disabled={disabled}
              >
                添加
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={16}>
          <div>已添加用户名</div>
          <Row>
            <Col>
              <Table
                rowKey="accountId"
                columns={formatUserColumns}
                dataSource={users}
                pagination={{ size: 'small', total }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Spin>
  );
};

Initiate.propTypes = {
  id: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Initiate;
